import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Place } from "@/types/common";

interface SelectedPlaceState {
  place: Place | null;
}

const initialState: SelectedPlaceState = {
  place: null,
};

const selectedPlaceSlice = createSlice({
  name: "selectedPlace",
  initialState,
  reducers: {
    setSelectedPlace: (state, action: PayloadAction<Place>) => {
      state.place = action.payload;
    },
    clearSelectedPlace: (state) => {
      state.place = null;
    },
  },
});

export const { setSelectedPlace, clearSelectedPlace } = selectedPlaceSlice.actions;
export default selectedPlaceSlice.reducer;
